import { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "../styles/LanguageSwitcher.css";

const LANGUAGES = [
  { code: "pt-BR", label: "PT", full: "Português (BR)" },
  { code: "en",    label: "EN", full: "English" },
  { code: "es",    label: "ES", full: "Español" },
  { code: "fr",    label: "FR", full: "Français" },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const current = LANGUAGES.find((l) => l.code === i18n.language) ?? LANGUAGES[0];

  const select = (code) => {
    i18n.changeLanguage(code);
    setOpen(false);
  };

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  return (
    <div className="lang-switcher" ref={ref}>
      <button
        className="lang-switcher__trigger"
        onClick={() => setOpen((o) => !o)}
        aria-haspopup="listbox"
        aria-expanded={open}
        aria-label={`Language: ${current.full}`}
      >
        <span className="lang-switcher__globe">🌐</span>
        <span className="lang-switcher__current">{current.label}</span>
        <span className={`lang-switcher__chevron ${open ? "lang-switcher__chevron--open" : ""}`}>▾</span>
      </button>

      {open && (
        <ul className="lang-switcher__dropdown" role="listbox">
          {LANGUAGES.map((lang) => (
            <li key={lang.code} role="option" aria-selected={lang.code === current.code}>
              <button
                className={`lang-switcher__option ${lang.code === current.code ? "lang-switcher__option--active" : ""}`}
                onClick={() => select(lang.code)}
              >
                <span className="lang-switcher__option-code">{lang.label}</span>
                <span className="lang-switcher__option-full">{lang.full}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
